import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { activeDirectoryForm } from '../active-directory.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { environment as stgEnviroment } from 'src/environments/environment.staging';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Injectable({
	providedIn: 'root',
})
export class ActiveDirectoryService {
	private getAdDataForm = environment.baseApiUrl + 'register/scheduleTask/configuration/ad';
	private putAdDataForm = environment.baseApiUrl + 'register/scheduleTask/configuration/ad';
	private executeAdExtractionUrl = stgEnviroment.baseApiUrl + 'ActiveDirectoryAPI?invokeName={invokeName}&dbSource={dbSource}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService,
		private NotificationService: NotificationService
	) {}

	getAdData(): Observable<activeDirectoryForm> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<activeDirectoryForm>(this.getAdDataForm, { headers: headers }).pipe(
			map((adData) => {
				adData.formatedStartAt = <any>adData.startAt;
				return adData;
			})
		);
	}

	putAdData(adForm: activeDirectoryForm): Observable<activeDirectoryForm> {
		const body = { ...adForm };
		body.toImport.users = body.toImport.users ? 1 : 0;
		body.toImport.equipments = body.toImport.equipments ? 1 : 0;
		body.toImport.groups = body.toImport.groups ? 1 : 0;
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.put<activeDirectoryForm>(this.putAdDataForm, adForm, { headers: headers });
	}

	executeAdExtraction(toImport: 'adComputerImport' | 'adGroupImport' | 'adUserImport'): Observable<any> {
		const executeAdExtractionUrl = this.executeAdExtractionUrl
			.replace('{invokeName}', toImport)
			.replace('{dbSource}', environment.supportcenter);
		return this.http.get<any>(executeAdExtractionUrl);
	}
}
